import { render, staticRenderFns } from "./RdigStatusPill.vue?vue&type=template&id=df95e1be&scoped=true&"
import script from "./RdigStatusPill.vue?vue&type=script&lang=js&"
export * from "./RdigStatusPill.vue?vue&type=script&lang=js&"
import style0 from "./RdigStatusPill.vue?vue&type=style&index=0&id=df95e1be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df95e1be",
  null
  
)

export default component.exports